import factory from '../requestFactory';

export default async({clinic_id,specialization_id}) => {
    let params = {}
    if(clinic_id){
        params['clinic_id'] = clinic_id
    }
    if(specialization_id){
        params['specialization_id'] = specialization_id
    }
    return factory()
        .get('/doctors',{params:params});
}
